import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
//import { initHeroSequence, initMobileHeroSequence } from './sections/hero-sequence'

gsap.registerPlugin(ScrollTrigger)

if ($('section.hero').length) {

  let orange_container = '.hero'
  let header = 'header .header-row'
  let burger = '.js-open-menu'
  let scroll_length = 500
  const background_color_tl = gsap.timeline({
    scrollTrigger: {
      trigger: orange_container,
      pin: true,
      scrub: true,
      end: () => `+=` + scroll_length,
      onUpdate: function ({ progress, direction, isActive }) {
        if (progress <= 0.9){
          $('header').addClass('fixed')
          $(header).css('top', 0)
        } else {
          $('header').removeClass('fixed')
          let from_top = scroll_length * progress
          $(header).css('top', from_top)
        }
      },
    }
  })
  background_color_tl.to(orange_container, { duration: 1, backgroundColor: '#C60C30', ease: "none" })

}




//export { initHeaderMenuSequence, initHeaderMobile }